const initialState = {
    applicationConfig:{},
    getGoUrls:{},
    countries: [],
    configCountries: []
};

const AppReducer  = (state=initialState,action) => {
    switch(action.type){
        case 'SET_APPLICATION_CONFIG':{
            return  {
                ...state,
                applicationConfig:action.value
            }
        }        
        case 'SET_GO_URLS':{
            return {
                ...state,
                getGoUrls:action.value
            }
        }
        case 'SET_COUNTRY_LIST' : {
            return {
                ...state,
                countries : action.value
            }
        }
        case 'SET_CONFIG_COUNTRY' : {
            return {
                ...state,
                addressEnabledCountryList : action.value
            }
        }
        case 'SET_FEATURE_FLAG' : {
            return {
                ...state,
                featureFlags : action.value
            }
        }
        default:
            return state;
    }

};

export default AppReducer;
